import styled from '@emotion/styled';

export const WithdrawLoadingModalContainer = styled.div`
  width: 100%;
  min-width: 600px;
  max-width: 600px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 600px;
  max-width: 600px;
  margin-top: 50px;
`;
